import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import { pilarPublicidad } from '../sortilegioContent';

const PilarPublicidad = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <SectionHeader
        overline={pilarPublicidad.overline}
        title={pilarPublicidad.title}
        subtitle={pilarPublicidad.subtitle}
        icon="public"
        align="left"
        maxWidth="100%"
      />
      <Grid container spacing={3}>
        {pilarPublicidad.channels.map((item) => (
          <Grid item xs={12} md={4} key={item.canal}>
            <GlassCard data-aos="fade-up" hover={false}>
              <Box
                sx={{
                  px: 3,
                  py: 1.5,
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                  {item.canal}
                </Typography>
              </Box>
              <Box p={3}>
                <Typography variant="caption" color="secondary" sx={{ fontWeight: 800, letterSpacing: 0.8 }}>
                  Enfoque
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.7, mt: 0.75, mb: 2.5 }}>
                  {item.enfoque}
                </Typography>
                <Typography variant="caption" color="primary" sx={{ fontWeight: 800, letterSpacing: 0.8 }}>
                  Impacto esperado
                </Typography>
                <Typography sx={{ lineHeight: 1.7, mt: 0.75, fontWeight: 600 }}>
                  {item.impacto}
                </Typography>
              </Box>
            </GlassCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PilarPublicidad;
